import ToolInsertMedia from '../plugins/MediaPlugin/tools/ToolInsertMedia';
import ToolInsertCalloutBlock, {
  ToolInsertInfoBlock,
  ToolInsertNoteBlock,
  ToolInsertTipBlock,
  ToolInsertWarningBlock,
} from '../plugins/InfoBlockPlugin/tools/ToolInsertInfoBlock';

import ToolDelete from './ToolDelete';
import ToolInsertSpaceAbove from './ToolInsertSpaceAbove';
import ToolInsertSpaceBelow from './ToolInsertSpaceBelow';

import ToolUndo from '../collaboration/tools/ToolUndo';
import ToolRedo from '../collaboration/tools/ToolRedo';

import ToolBulletedList from '../plugins/ListPlugin/tools/ToolBulletedList';
import ToolNumberedList from '../plugins/ListPlugin/tools/ToolNumberedList';
import ToolCheckList from '../plugins/ListPlugin/tools/ToolCheckList';
import ToolDefinitionList from '../plugins/ListPlugin/tools/ToolDefinitionList';
import ToolIncreaseIndent from '../plugins/ListPlugin/tools/ToolIncreaseIndent';
import ToolDecreaseIndent from '../plugins/ListPlugin/tools/ToolDecreaseIndent';
import {
  ToolBold,
  ToolCopyFormat,
  ToolItalic,
  ToolPasteFormat,
  ToolUnderline,
  ToolStrikethrough,
  ToolCodeSnippet,
} from '../plugins/Formatting/tools';
import ToolTextColor from '../plugins/Formatting/tools/ToolTextColor';
import ToolTextHighlight from '../plugins/Formatting/tools/ToolTextHighlight';
import ToolFontSize from '../plugins/Formatting/tools/ToolFontSize';
import ToolFontFamily from '../plugins/Formatting/tools/ToolFontFamily';
import ToolClearFormatting from '../plugins/Formatting/tools/ToolClearFormatting';

import ToolToggleParagraph from '../plugins/Blocks/tools/ToolToggleParagraph';
import ToolToggleHeading1 from '../plugins/Blocks/tools/ToolToggleHeading1';
import ToolToggleHeading2 from '../plugins/Blocks/tools/ToolToggleHeading2';
import ToolToggleHeading3 from '../plugins/Blocks/tools/ToolToggleHeading3';
import ToolToggleHeading4 from '../plugins/Blocks/tools/ToolToggleHeading4';
import ToolToggleHeading5 from '../plugins/Blocks/tools/ToolToggleHeading5';
import ToolToggleHeading6 from '../plugins/Blocks/tools/ToolToggleHeading6';
import ToolToggleQuote from '../plugins/Blocks/tools/ToolToggleQuote';
import ToolToggleCode from '../plugins/Blocks/tools/ToolToggleCode';

import ToolInsertLink from '../plugins/LinkPlugin/tools/ToolInsertLink';
import ToolUnlink from '../plugins/LinkPlugin/tools/ToolUnlink';
import ToolEditLink from '../plugins/LinkPlugin/tools/ToolEditLink';
import ToolOpenLink from '../plugins/LinkPlugin/tools/ToolOpenLink';

import ToolInsertEmbed from '../plugins/EmbedPlugin/tools/ToolInsertEmbed';

import ToolInsertLabelPill from '../plugins/LabelPillPlugin/tools/ToolInsertLabelPill';
import {
  ToolLabelPillColorGray,
  ToolLabelPillColorBlue,
  ToolLabelPillColorGreen,
  ToolLabelPillColorYellow,
  ToolLabelPillColorRed,
} from '../plugins/LabelPillPlugin/tools/ToolLabelPillColor';

import {
  ToolIndentCode,
  ToolOutdentCode,
} from '../plugins/CodeBlockPlugin/tools/ToolIndentCode';
import ToolChooseCodeLanguage from '../plugins/CodeBlockPlugin/tools/ToolChooseCodeLanguage';

import {
  ToolInfoBlockTypeInfo,
  ToolInfoBlockTypeNote,
  ToolInfoBlockTypeWarning,
  ToolInfoBlockTypeTip,
} from '../plugins/InfoBlockPlugin/tools/ToolInfoBlockType';

import ToolInsertDividerLine from '../plugins/DividerLinePlugin/tools/ToolInsertDividerLine';

import ToolToggleTableOfContents from '../plugins/TableOfContentsPlugin/tools/ToolToggleTableOfContents';

import ToolInsertEmoji from '../plugins/EmojiPlugin/tools/ToolInsertEmoji';
import ToolAlignLeft from '../plugins/AlignmentPlugin/tools/ToolAlignLeft';
import ToolAlignRight from '../plugins/AlignmentPlugin/tools/ToolAlignRight';
import ToolAlignCenter from '../plugins/AlignmentPlugin/tools/ToolAlignCenter';
import ToolAlignJustify from '../plugins/AlignmentPlugin/tools/ToolAlignJustify';

import ToolInsertTable from '../plugins/TablePlugin/tools/ToolInsertTable';
import {
  ToolInsertRowsOrColumns,
  ToolInsertColumnAfter,
  ToolInsertColumnBefore,
  ToolInsertRowAfter,
  ToolInsertRowBefore,
} from '../plugins/TablePlugin/tools/ToolInsertRowsOrColumns';
import ToolDeleteRowsOrColumns from '../plugins/TablePlugin/tools/ToolDeleteRowsOrColumns';
import ToolDeleteColumn from '../plugins/TablePlugin/tools/ToolDeleteColumn';
import ToolDeleteRow from '../plugins/TablePlugin/tools/ToolDeleteRow';
import ToolDeleteTable from '../plugins/TablePlugin/tools/ToolDeleteTable';
import ToolTableFullWidth from '../plugins/TablePlugin/tools/ToolTableFullWidth';
import {
  ToolTableHeaderRow,
  ToolTableHeaderColumn,
} from '../plugins/TablePlugin/tools/ToolTableHeaders';
import ToolMergeCells from '../plugins/TablePlugin/tools/ToolMergeCells';
import ToolSplitCells from '../plugins/TablePlugin/tools/ToolSplitCells';
import ToolCellAlign from '../plugins/TablePlugin/tools/ToolCellAlign';
import {
  ToolCellVerticalAlignBottom,
  ToolCellVerticalAlignMiddle,
  ToolCellVerticalAlignTop,
} from '../plugins/TablePlugin/tools/ToolCellVerticalAlign';
import ToolCellBackgroundColor from '../plugins/TablePlugin/tools/ToolCellBackgroundColor';
import ToolTableBorderColor from '../plugins/TablePlugin/tools/ToolTableBorderColor';
import ToolTableClearContent from '../plugins/TablePlugin/ToolTableClearContent';
import ToolResetColumnWidths from '../plugins/TablePlugin/tools/ToolResetColumnWidths';
import ToolTableOptions from '../plugins/TablePlugin/tools/ToolTableOptions';

import ToolAddSnippet from '../plugins/SharedSnippetPlugin/tools/ToolAddSnippet';
import ToolEditSnippet from '../plugins/SharedSnippetPlugin/tools/ToolEditSnippet';

import ToolFullScreen from './ToolFullScreen';
import ToolCreateCommentAnnotation, {
  ToolCreateAnnotation,
} from '../plugins/AnnotationsPlugin/tools/ToolCreateCommentAnnotation';
import ToolShowComments from '../plugins/AnnotationsPlugin/tools/ToolShowComments';

import fireToolAction from './fireToolAction';

import ToolWritingAssistant from '../plugins/WritingAssistantPlugin/tools/ToolWritingAssistant';
import ToolWritingAssistantSelection from '../plugins/WritingAssistantPlugin/tools/ToolWritingAssistantSelection';
import ToolLineHeight from '../plugins/LineHeightPlugin/tools/ToolLineHeight';

import ToolWordCount from '../plugins/WordCountPlugin/tools/ToolWordCount';

export default {
  fireToolAction,

  ToolInsertMedia,
  ToolInsertCalloutBlock,
  ToolInsertInfoBlock,
  ToolInsertNoteBlock,
  ToolInsertTipBlock,
  ToolInsertWarningBlock,

  ToolDelete,

  ToolUndo,
  ToolRedo,

  ToolBulletedList,
  ToolNumberedList,
  ToolCheckList,
  ToolDefinitionList,
  ToolIncreaseIndent,
  ToolDecreaseIndent,

  ToolBold,
  ToolCopyFormat,
  ToolItalic,
  ToolPasteFormat,
  ToolUnderline,
  ToolStrikethrough,
  ToolCodeSnippet,
  ToolTextColor,
  ToolTextHighlight,
  ToolFontSize,
  ToolFontFamily,
  ToolLineHeight,
  ToolClearFormatting,

  ToolToggleParagraph,
  ToolToggleHeading1,
  ToolToggleHeading2,
  ToolToggleHeading3,
  ToolToggleHeading4,
  ToolToggleHeading5,
  ToolToggleHeading6,
  ToolToggleQuote,
  ToolToggleCode,

  ToolIndentCode,
  ToolOutdentCode,

  ToolInfoBlockTypeInfo,
  ToolInfoBlockTypeNote,
  ToolInfoBlockTypeWarning,
  ToolInfoBlockTypeTip,

  ToolInsertLink,
  ToolUnlink,
  ToolEditLink,
  ToolOpenLink,

  ToolInsertEmbed,

  ToolInsertLabelPill,
  ToolLabelPillColorGray,
  ToolLabelPillColorBlue,
  ToolLabelPillColorGreen,
  ToolLabelPillColorYellow,
  ToolLabelPillColorRed,

  ToolInsertDividerLine,
  ToolToggleTableOfContents,

  ToolChooseCodeLanguage,

  ToolInsertEmoji,

  ToolInsertTable,
  ToolInsertRowsOrColumns,
  ToolInsertRowBefore,
  ToolInsertRowAfter,
  ToolInsertColumnBefore,
  ToolInsertColumnAfter,
  ToolDeleteRowsOrColumns,
  ToolDeleteColumn,
  ToolDeleteRow,
  ToolDeleteTable,

  ToolTableFullWidth,
  ToolTableHeaderRow,
  ToolTableHeaderColumn,
  ToolMergeCells,
  ToolSplitCells,
  ToolCellAlign,
  ToolCellVerticalAlignBottom,
  ToolCellVerticalAlignMiddle,
  ToolCellVerticalAlignTop,
  ToolCellBackgroundColor,
  ToolTableBorderColor,
  ToolTableClearContent,
  ToolResetColumnWidths,

  ToolInsertSpaceAbove,
  ToolInsertSpaceBelow,
  ToolTableOptions,

  ToolAlignLeft,
  ToolAlignRight,
  ToolAlignCenter,
  ToolAlignJustify,

  ToolAddSnippet,
  ToolEditSnippet,

  ToolFullScreen,
  ToolWritingAssistant,
  ToolWritingAssistantSelection,
  ToolCreateAnnotation,
  ToolCreateCommentAnnotation,
  ToolShowComments,

  ToolWordCount,
};
